const VISITOR_KEY = 'vlt_visitor_id';
const SESSION_KEY = 'vlt_session_id';
const CID_QUERY_KEY = 'cid';
const CID_SESSION_KEY = 'vlt_cid';
const CID_PATTERN = /^[a-zA-Z0-9_.:-]{1,128}$/;
const visitorMemory = new Map<string, string>();
const sessionMemory = new Map<string, string>();

function getStorage(kind: 'localStorage' | 'sessionStorage'): Storage | null {
  try {
    return window[kind];
  } catch {
    return null;
  }
}

function safeGet(
  kind: 'localStorage' | 'sessionStorage',
  memory: Map<string, string>,
  key: string,
): string | null {
  const storage = getStorage(kind);
  if (!storage) return memory.get(key) ?? null;

  try {
    return storage.getItem(key);
  } catch {
    return memory.get(key) ?? null;
  }
}

function safeSet(
  kind: 'localStorage' | 'sessionStorage',
  memory: Map<string, string>,
  key: string,
  value: string,
): void {
  const storage = getStorage(kind);
  if (!storage) {
    memory.set(key, value);
    return;
  }

  try {
    storage.setItem(key, value);
  } catch {
    memory.set(key, value);
  }
}

function randomId(prefix: 'vltv' | 'vlts'): string {
  return `${prefix}_${crypto.randomUUID()}`;
}

export function getOrCreateVisitorId(): string {
  const stored = safeGet('localStorage', visitorMemory, VISITOR_KEY);
  if (stored && /^vltv_/.test(stored)) return stored;

  const next = randomId('vltv');
  safeSet('localStorage', visitorMemory, VISITOR_KEY, next);
  return next;
}

export function getOrCreateSessionId(): string {
  const stored = safeGet('sessionStorage', sessionMemory, SESSION_KEY);
  if (stored && /^vlts_/.test(stored)) return stored;

  const next = randomId('vlts');
  safeSet('sessionStorage', sessionMemory, SESSION_KEY, next);
  return next;
}

function sanitizeCid(value: string | null | undefined): string | null {
  const normalized = value?.trim();
  if (!normalized || !CID_PATTERN.test(normalized)) return null;
  return normalized;
}

function readCidFromUrl(): string | null {
  try {
    return sanitizeCid(new URL(window.location.href).searchParams.get(CID_QUERY_KEY));
  } catch {
    return null;
  }
}

export function getOrCreateCid(): string | null {
  const fromUrl = readCidFromUrl();
  if (fromUrl) {
    safeSet('sessionStorage', sessionMemory, CID_SESSION_KEY, fromUrl);
    return fromUrl;
  }

  return sanitizeCid(safeGet('sessionStorage', sessionMemory, CID_SESSION_KEY));
}
